import { render } from "./OrderIndex.vue?vue&type=template&id=149d9242&scoped=true"
import script from "./OrderIndex.vue?vue&type=script&lang=js"
export * from "./OrderIndex.vue?vue&type=script&lang=js"

import "./OrderIndex.vue?vue&type=style&index=0&id=149d9242&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149d9242"]])

export default __exports__